import { CHECK_SCHEDULE_REQUEST, CHECK_SCHEDULE_REQUEST_ERROR, CHECK_SCHEDULE_REQUEST_SUCCESS, DOCTOR_LISTING_PAGINATION, REQUEST_BLOG, REQUEST_BLOG_ERROR, REQUEST_BLOG_SUCCESS, REQUEST_DOCTOR_SEARCH, REQUEST_DOCTOR_SEARCH_ERROR, REQUEST_DOCTOR_SEARCH_SUCCESS } from './Constants';

// userReducer.js
const initialState = {
    loading: false,
    error: null,
};

export const doctorListReducer = (state = initialState, action) => {
    switch (action.type) {
    case REQUEST_DOCTOR_SEARCH:
        return { ...state, loading: true };
    case REQUEST_DOCTOR_SEARCH_SUCCESS:
        return { ...state, doctorList: action.payload, loading: false };
    case REQUEST_DOCTOR_SEARCH_ERROR:
        return { ...state, loading: false };
    case DOCTOR_LISTING_PAGINATION:
        return { ...state, pageCount: action.pageCount };
    case REQUEST_BLOG:
        return { ...state, scheduleData : null, loading: true };
    case REQUEST_BLOG_SUCCESS:
        return { ...state, blogList: action.payload, loading: false };
    case REQUEST_BLOG_ERROR:
        return { ...state, loading: false };
    case CHECK_SCHEDULE_REQUEST:
        return { ...state, loading: true };
    case CHECK_SCHEDULE_REQUEST_SUCCESS:
        return { ...state, scheduleData: action.payload, loading: false };
    case CHECK_SCHEDULE_REQUEST_ERROR:
        return { ...state, loading: false };
    default:
        return state;
    }
};
